import { handlePagingAll } from "../../../../components/api/APIUtilities";

const getUrl = (type = "player") => {
  switch (type) {
    case "player": return "/players"
    default: return "/pairings"
  }
}

const getParams = (type = "player", eventId, currentRound) => {
  const params = { eventId };
  if (currentRound >= 1) params.podNum = 1;

  switch (type) {
    case "pairing": {
      return {
        ...params,
        pairingType: "Pairing",
        "expand[]": ["player1", "player2", "player1Game", "player2Game"],
      }
    }
    case "seatedPairing": {
      return {
        ...params,
        pairingType: "SeatedPairing",
      }
    }
    case "teamPairing": {
      return {
        ...params,
        pairingType: "TeamPairing",
        "expand[]": [
          "teamPlayer1",
          "teamPlayer2",
          "player1Game",
          "player2Game",
        ],
      }
    }
    default: {
      return params
    }
  }
}

export const fetchDataArray = async (type = "player", eventId, currentRound, isDoubleElimination) => {
  if (!currentRound) return [];
  if (!(type === "player" || type === "pairing" || type === "seatedPairing" || type === "teamPairing")) return [];

  const url = getUrl(type)
  const params = getParams(type, eventId, currentRound)

  try {
    const result = await handlePagingAll(url, params)

    if (isDoubleElimination) {
      params.podNum = 2
      const doubleResult = await handlePagingAll(url, params);
      return [...result, ...doubleResult]
    }

    return result
  } catch (error) {
    console.error(error);
    return [];
  }
}